import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddColor = createAsyncThunk(
  "other/AddColor",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/color-create/`, data)
    return response.data
  }
); 

export const UpdateColor = createAsyncThunk(
  "other/UpdateColor",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/color-update/${data.id}/`, data)
    return response.data
  }
);

export const GetColorList = createAsyncThunk(
  "user/GetColorList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/color-list/`)
    return data
  }
);

export const DeleteColor = createAsyncThunk(
  "other/DeleteColor",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/color-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

